import { loadStripe } from "@stripe/stripe-js";

// loadStripe() memoizes internally, but keep a single module-level promise
// anyway so every caller shares the same Stripe.js instance.
export const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);
